import Hook from "../utils/hook"

export default Hook(`FormInput`, {
  actions: [
    {
      name: `dateTimeFocus`,
      type: `focus`,
    },
    {
      name: `dateTimeBlur`,
      type: `blur`,
    },
    {
      name: `dateTimeChange`,
      type: `change`,
    },
  ],
  defaultType: ``,
  isDateTime: false,

  mounted() {
    this.defaultType = this.el.type
    this.isDateTime = [`date`, `time`, `datetime-local`].includes(
      this.defaultType
    )

    if (this.isDateTime) this.initDateTime()
  },

  initDateTime() {
    this.attributeSet(`data-this-type`, this.defaultType)
    this.toggleDateTimeType()
    this.toggleCustomPlaceholderClass()
  },

  dateTimeFocusAction() {
    if (!this.isDateTime) return
    this.el.type = this.defaultType
    this.el.showPicker()
  },

  dateTimeBlurAction() {
    if (!this.isDateTime) return
    this.toggleDateTimeType()
    this.toggleCustomPlaceholderClass()
  },

  dateTimeChangeAction() {
    if (!this.isDateTime) return
    this.toggleCustomPlaceholderClass()
  },

  toggleDateTimeType() {
    if (this.el.placeholder && !this.el.value) this.el.type = `text`
  },

  toggleCustomPlaceholderClass() {
    if (this.el.value) this.classRemove(`is-placeholder`)
    else this.classAdd(`is-placeholder`)
  },
})
